import initSliderCards from '../shared/sliderCards';
import initSliderDestination from './slider';

export default ({ destination }) => {
  const { similar, slider } = destination;

  initSliderDestination(slider);
  initSliderCards(similar.id, similar.count);
};
